<template>
  <es-layout
    custom-class="backgroundConent"
    layout="{{['header', 'footer']}}"
    esMainStyle="{{ esMainStyle}}"
    useDefaultNavbar="{{false}}"
    navbarClickLeft="{{goback}}"
  >
    <block wx:if="{{!isMini}}">
      <view slot="header" class="navbarBg">
        <es-navbar onClickLeft="{{goHome}}"></es-navbar>
      </view>
    </block>
    <view class="backgroundStyle">
      <!-- 通用banner -->
      <banner
        class="banner"
        title="{{bannerTitle}}"
        wx:class="{{loginPageStatus?.quickLogin && 'quick'}}"
      ></banner>
      <block wx:if="{{loginPageStatus.alreadyLogin}}">
        <!-- 常用旅客信息入口 -->
        <passengers />
        <!-- 畅行会员 -->
        <cxvip-card isCxvip="{{loginPageStatus.isCxvip}}" />
      </block>
      <view class="es-login-form">
        <!-- 用户名 密码 输入 -->
        <block wx:if="{{loginPageStatus.commonLogin || loginPageStatus.changeUser}}">
          <view class="es-login-input">
            <input
              type="text"
              ref="name"
              class="inputStyle"
              placeholder="12306用户名/邮箱/手机号"
              wx:model="{{inputdata}}"
            />
          </view>
          <view class="es-login-input">
            <input
              type="{{passwordType}}"
              ref="password"
              class="inputStyle"
              wx:style="{{fontSizeAdapt}}"
              placeholder="请输入12306密码"
              wx:model="{{passWordData}}"
            />
            <view class="icon-eye-close" bindtap="eyehandle">
              <block wx:if="{{!eyeState}}"
                ><image
                  src="https://pt-starimg.didistatic.com/static/starimg/img/LpvhCITOpN1642147541419.png"
                  class="es-eye"
                ></image
              ></block>
              <block wx:else>
                <image
                  src="https://pt-starimg.didistatic.com/static/starimg/img/FLGAZitaXS1642147590072.png"
                  class="es-eye"
                ></image
              ></block>
            </view>
          </view>
          <view wx:if="{{accountChannel !== 'app'}}" class="es-login-input">
            <input
              type="text"
              ref="digit"
              class="inputStyle"
              placeholder="请输入登录账号绑定的证件号后四位"
              wx:model="{{digitdata}}"
            />
          </view>
          <view class="form-block"></view>
        </block>
        <!-- 协议部分 -->
        <view wx:if="{{!loginPageStatus.alreadyLogin}}" class="es-rm-agree-box">
          <view class="es-login-agree-left">
            <view class="es-rm-agreement">
              <es-checkbox-group wx:model="{{checkboxValue}}" direction="row">
                <es-checkbox
                  label-position="right"
                  name="1"
                  shap="square"
                  iconSize="{{16}}"
                  icon-style="{{{borderRadius: '6px'}}}"
                  useIconSlot="{{true}}"
                  color="#338FFF"
                >
                  <image
                    mode="aspectFit"
                    class="es-zdy-icon"
                    wx:if="{{statusCheckout}}"
                    slot="icon"
                    src="https://ut-static.udache.com/webx/sfc/f2m654Y-v5zvwcBCQw1aO.png"
                  >
                  </image>
                  <view class="es-rm-checkbox">我阅读并同意以下协议<view bindtap="goto" class="es-rm-navigator highlight es-line">《个人信息处理授权协议》</view></view>
                </es-checkbox>
              </es-checkbox-group>
            </view>
            
          </view>
          <view
            wx:if="{{loginPageStatus.commonLogin || loginPageStatus.changeUser}}"
            class="es-rm-navigator"
            bindtap="goNext"
            >忘记密码</view
          >
        </view>
        <view
          wx:if="{{loginPageStatus.quickLogin}}"
          class="buttonStyle login"
          bindtap="quickLoginHandle"
          >一键登录12306</view
        >
        <view
          wx:if="{{loginPageStatus.commonLogin || loginPageStatus.changeUser}}"
          class="buttonStyle login"
          bindtap="submit"
          >登录12306</view
        >
        <view
          wx:if="{{loginPageStatus.commonLogin}}"
          class="buttonStyle register"
          bindtap="goRegister"
          >没有账号？30s极速注册</view
        >
        <!-- 历史账号 -->
        <historyAccount
          wx:if="{{loginPageStatus.changeUser}}"
          class="history-account"
        ></historyAccount>
      </view>
    </view>
    <!-- 快捷入口 -->
    <view slot="footer" wx:if="{{quickEntrance && !isFoucs}}" class="quick-entrance">
      <view wx:for="{{quickEntrance}}" bindtap="item.cb" class="entrance-item">{{
        item.text
      }}</view>
    </view>
    <!-- 核验弹窗 -->
    <es-riskmanagement loginType="login"></es-riskmanagement>
    <!-- 协议弹窗 -->
    <es-dialog id="es-dialog-conceal">
      <view slot="content">
        <view class="protocol text">我阅读并同意以下协议</view>
        <view class="protocol url" bindtap="goto">《个人信息处理授权协议》</view>
        <view class="protocol text">同意受本协议约束</view>
      </view>
    </es-dialog>
    <!-- 去注册出行会员弹窗 -->
    <cxvip-popup />
  </es-layout>
</template>

<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { is } from '@didi/webx-js'
  import store from '@/store'
  import { RSA2_ENCRYPT } from '@/common/rsa_crypto'
  import { getStorage } from '@/utils/storage'
  import { desensitize } from '@/utils/index'
  import { innerRouter, pagePath } from "@/common/jump";
  import { trackEvent } from '@/common/track'
  import { isWXMini, isALIMini } from '@/common/constant'
  import Dialog from '@didi/es-mpx-ui/lib/dialog/functional'
  import { goback } from "@didi/spring-base";

  createPage({
    data: {
      checkboxValue: [],
      passWordData: '',
      inputdata: '',
      digitdata: '',
      eyeState: false,
      esMainStyle: {
        'background': '#fff'
      },
      isFoucs: false,
      cxvipPopupHasShow: false,
    },
    computed: {
      ...store.mapState({
        userInfo12306: 'login12306.userInfo12306',
        cxvipPopupShow: 'login12306.cxvipPopupShow',
        changeUserStatus: 'login12306.changeUserStatus',
        accountChannel: 'login12306.accountChannel',
      }),
      ...store.mapGetters({
        canQuickLoginAccount: 'login12306.canQuickLoginAccount'
      }),
      isMini() {
        return isWXMini || isALIMini
      },
      loginPageStatus() {
        const isLogin = !!this.userInfo12306?.account_with_star
        const isCxvip = !!this.userInfo12306?.cxvip
        const changeUser = this.changeUserStatus
        return {
          commonLogin: !isLogin && !this.canQuickLoginAccount && !changeUser,
          quickLogin: !isLogin && this.canQuickLoginAccount && !changeUser,
          alreadyLogin: isLogin && !changeUser,
          changeUser: changeUser,
          isCxvip
        }
      },
      bannerTitle() {
        const {
          commonLogin,
          quickLogin,
          alreadyLogin,
          changeUser
        } = this.loginPageStatus
        return alreadyLogin
          ? this.userInfo12306.account_with_star
          : quickLogin
            ? this.canQuickLoginAccount.account_with_star
            : '登录12306账号'
      },
      quickEntrance() {
        const {
          commonLogin,
          quickLogin,
          alreadyLogin,
          changeUser
        } = this.loginPageStatus
        return changeUser
          ? [{
              text: '没有账号？极速注册',
              cb: () => {
                this.goRegister()
              }
            }]
          : quickLogin || alreadyLogin
            ? [{
                text: '切换账号',
                cb: () => {
                  this.setChangeUserStatus(true)
                }
              },{
                text: '常见问题',
                cb: () => {
                  innerRouter.push(pagePath().ICKETPURCHASENOTICE)
                }
              }]
            : null
      },
      passwordType() {
        const type = this.eyeState ? 'text' : 'password'
        return type
      },
      statusCheckout() {
        return this.checkboxValue.length ? true : false
      },
      fontSizeAdapt() {        
        const size =  is('android') ? '16px' : this.eyeState ? '16px' : '10px'
        return { fontSize: size}
      },
    },
    methods: {
      ...store.mapActions({
        loginAction12306: 'login12306.loginAction12306',
        updateAllUserAccount: 'login12306.updateAllUserAccount',
        updateTravelerListForLoginPage: 'contacts.updateTravelerListForLoginPage',
      }),
      ...store.mapMutations({
        setTravelerList: 'contacts.setTravelerList',
        pagePathAction: 'login12306.pagePathAction',
        verifyCxvip: 'login12306.verifyCxvip',
        checkCxvipPupup: 'login12306.checkCxvipPupup',
        setChangeUserStatus: 'login12306.setChangeUserStatus',
      }),
      // 快捷登录
      quickLoginHandle() {
        this.setTravelerList([])
        if (!this.checkboxValue.length) {
          Dialog.confirm({
            title: '同意授权确认',
            cancelButtonText: '取消',
            confirmButtonText: '同意并继续',
            selector: '#es-dialog-conceal',
            confirm: () => {
              this.checkboxValue.push('1')
              this.quickLoginHandleCheck()
            },
            cancel: () => {}
          })
          return
        }
        this.quickLoginHandleCheck()
      },
      async quickLoginHandleCheck() {
        const {
          account,
          account_with_star
        } = this.canQuickLoginAccount
        const { from } = this.$mpxRoute.query
        this.loginAction12306({
          type: 1,
          account,
          account_with_star,
          tickets12306: from === 'tickets12306' ? 1 : 0
        })
      },
      goHome() {
        if(this.changeUserStatus) {
          this.setChangeUserStatus(false)
          return
        }
        const { from } = this.$mpxRoute.query
        if(from === 'tickets12306') {
          innerRouter.push(pagePath().ORDERLIST)
        } else {
          goback()
        }
      },
      goRegister(){
        trackEvent('userteam_train_12306land_reg_ck', 'UT-火车票-12306登陆-注册-点击')
        innerRouter.push(pagePath().REGISTER)
      },
      goNext() {
        trackEvent('userteam_train_12306land_forget_ck', 'UT-火车票-12306登陆-忘记用户名密码-点击')
        innerRouter.push(pagePath().PASSWORDRETRIEVAL)
      },
      async goto() {
        if (__mpx_mode__ === 'web') {
          const ua = navigator.userAgent.toLowerCase()
          const isUc = ua.indexOf('ucbrowser') > -1
          if (isUc) {
            this.eyeState = true
          }
        }
        //添加国际域名
        let goToUrl = 'https://page.udache.com/driver-activity-biz/baichuan-policy-agreement/index.html?mode=2\u0026policy_id=50071874'
        innerRouter.goTo(goToUrl)
      },
      eyehandle() {
        if (this.eyeState) {
          this.eyeState = false
        } else {
          this.eyeState = true
        }
      },
      checkInput(){
        const that = this
        if (this.inputdata.trim().length === 0) {
          mpx.showToast({
            title: '请输入账号名',
            icon: 'error',
            mask: true,
          })
          return false
        }
        if (this.passWordData.trim().length === 0) {
          mpx.showToast({
            title: '请输入密码',
            icon: 'error',
            mask: true,
          })
          return false
        }
        if (this.digitdata.trim().length === 0 && this.accountChannel !== 'app') {
          mpx.showToast({
            title: '请输入证件号后四位',
            icon: 'error',
            mask: true,
          })
          return false
        }
        if (!this.checkboxValue.length) {
          Dialog.confirm({
            title: '同意授权确认',
            cancelButtonText: '取消',
            confirmButtonText: '同意并继续',
            selector: '#es-dialog-conceal',
            confirm: () => {
              this.checkboxValue.push('1')
              this.submit()
            },
            cancel: () => {}
          })
          return false
        }
        return true
      },
      submit() {
        this.inputBlur()
        this.setTravelerList([])
        this.getMaskAccount(this.inputdata)
        const is_success_flag = this.checkInput()
        const trackParmas={
          is_success: is_success_flag ? 1 :0
        }
        trackEvent('userteam_train_12306land_land_ck', 'UT-火车票-12306登陆-登陆-点击',trackParmas)
        if (!is_success_flag) return
        const password = this.passWordData && this.passWordData.trim()
        const inputdata = this.inputdata && this.inputdata.trim()
        const digitdata = this.digitdata && this.digitdata.trim()
        const { from } = this.$mpxRoute.query
        this.loginAction12306({
          type: 0,
          password: RSA2_ENCRYPT(password),
          account: RSA2_ENCRYPT(inputdata),
          is_digit: digitdata,
          account_with_star: this.getMaskAccount(inputdata),
          tickets12306: from === 'tickets12306' ? 1 : 0
        })
      },
      getMaskAccount(inputdata) {
        var maskAccount = ''
        var str = '*'
        if (inputdata?.includes('@')) {
          var emialPre = inputdata.slice(0, inputdata.lastIndexOf('@'))
          if (emialPre?.length > 4) {
            maskAccount = desensitize(emialPre, 2, emialPre?.length - 2)
          } else {
            maskAccount = desensitize(emialPre, 1, emialPre?.length)
          }
          maskAccount += inputdata.slice(inputdata.lastIndexOf('@'))
        } else if (inputdata?.length >= 11) {
          maskAccount = desensitize(inputdata, 3, inputdata?.length - 4)
        } else {
          maskAccount = desensitize(inputdata, 2, inputdata?.length - 2)
        }
        return maskAccount
      },
      clearFormData() {
        this.checkboxValue = []
        this.passWordData = ''
        this.digitdata = ''
        this.inputdata = ''
      },
      goback() {
        goback()
      },
      inputBlur() {
        const inputRefArr = ['name','password', 'digit']
        inputRefArr.forEach((item) => {
            this.$refs?.[item]?.$el?.blur && this.$refs?.[item]?.$el?.blur()
        })
      }
    },
    created() {
      this.pagePathAction({
        path: this.$mpxRoute.path,
        query: this.$mpxRoute.query
      })
    },
    mounted() {
      trackEvent('userteam_train_12306land_sw', 'UT-火车票-12306登陆-曝光')
    },
    async activated() {
      this.verifyCxvip(false)
      await this.updateAllUserAccount()
      if(!this.cxvipPopupHasShow || this.cxvipPopupShow) {
        this.checkCxvipPupup()
        this.cxvipPopupHasShow = true
      }
      if(this.changeUserStatus && !this.userInfo12306?.account_with_star) {
        this.setChangeUserStatus(false)
      }
      // 登录状态刷新乘车人数量
      this.loginPageStatus.alreadyLogin && this.updateTravelerListForLoginPage()
      if (__mpx_mode__ === 'web') {
        const ua = navigator.userAgent.toLowerCase()
        const isUc = ua.indexOf('ucbrowser') > -1
        if (isUc) {
          this.eyeState = false
        }
      }
    },
    watch: {
      // 一键登录默认勾选协议 又不默认勾选了
      // 'loginPageStatus.quickLogin': {
      //   immediate: true,
      //   handler(val, valPrev) {
      //     if(!valPrev && val) {
      //       this.checkboxValue.push('1')
      //     }
      //   },
      // },
      // 切换账号清空选中状态
      'loginPageStatus.changeUser': {
        immediate: true,
        handler(val, valPrev) {
          if(!valPrev && val) {
            this.clearFormData()
          }
        },
      },
    },
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  /deep/ .es-dialog__confirm
    color #338FFF !important
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color $train-color-666
    &.url
      color #338FFF
  .navbarBg
    background-color $train-color-fff
  .backgroundConent
    background-color #FFFFFF
    height 100%
  .es-rm-agree-box
    display flex
    justify-content space-between
    .es-login-agree-left
      display flex
      align-items center
      flex 1
      flex-wrap wrap
      .es-rm-agreement
        >>> .es-rm-checkbox
          color #666
        >>> .es-checkbox--checked
          border none
    .es-rm-navigator
      display flex
      align-items center
      font-size 12px !important
      line-height 1
      color #000
      text-decoration none
      letter-spacing 0
      &.highlight
        color #338FFF
      &.es-line
        display inline
  .es-rm-checkbox
    font-size 12px
    color $train-color-999
    margin-left -5px
  .buttonStyle
    box-sizing border-box
    height 48px
    font-size 16px
    border-radius 8px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0
    display flex
    align-items center
    justify-content center
    &.login
      color #fff
      background #338FFF
      margin-top 12px
    &.register
      color #338FFF
      border 1px solid #338FFF
      margin-top 12px
  .backgroundStyle
    padding 19px 24px 24px
    background-color #FFFFFF
    .banner
      margin-bottom 37px
      &.quick
        margin-bottom 53px
    .history-account
      margin-top 32px
  .inputStyle
    font-size 16px
    outline none
    flex 1
    height 20px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0px
    color #000000
    -webkit-tap-highlight-color transparent
    &::placeholder
      font-family PingFangSC-Regular
      font-size 16px
      font-weight normal
      line-height 1
      letter-spacing 0px
      color #999999
  .es-login-input
    height 56px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px #EEEEEE solid
    position relative
    .icon-eye-close
      flex none
      margin-left 8px
      @extend .expand-click
      width 20px
      height 20px
      .es-eye
        width 16px
        height 16px
  .form-block
    height 24px
  .es-zdy-icon
    width 16px
    height 16px
  .quick-entrance
    padding-bottom 57px
    box-sizing border-box
    width 100%
    display flex
    align-items center
    justify-content center
    .entrance-item
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      height 24px
      letter-spacing 0px
      color #000000
      margin 0 30px
      position relative
      &+.entrance-item
        margin-left 31px
        &::before
          content ''
          position absolute
          left -30px
          top 3px
          width 1px
          height 10px
          background-color #999
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'es-riskmanagement': './components/rm/risk-management',
      'es-checkbox': '@/es-mpx-ui/lib/checkbox',
      'es-checkbox-group': '@/es-mpx-ui/lib/checkbox-group',
      banner: './components/common/banner',
      historyAccount: './components/common/history-account',
      passengers: './components/common/passengers',
      'es-layout': '@/es-mpx-ui/lib/layout',
      'cxvip-card': './components/common/cxvip-card',
      'cxvip-popup': './components/common/cxvip-popup'
    }
  }
</script>

